import Controller from '@ember/controller';
import { task } from 'ember-concurrency';
import { inject as service } from '@ember/service';
import GroupCondition from 'cio/app-models/conditions/group';
import serialize from 'cio/utils/conditions/serialize';
import { createCondition } from 'cio/utils/conditions';
import { DATA_INDEX_TYPE_ACTIVITY_LOGS } from 'cio/utils/data-index';
import DS from 'ember-data';
import RouterService from '@ember/routing/router-service';
import AttributeModel from 'cio/models/attribute';
import EventModel from 'cio/models/event';

let createConditionsJSON = (type: string, name: string) => {
  let groupCondition = GroupCondition.create();
  let condition = createCondition(type);
  condition.name = name;
  (groupCondition.children as any[]).pushObject(condition);

  return serialize(groupCondition);
};

export default class ItemController extends Controller {
  @service store!: DS.Store;
  @service router!: RouterService;

  declare model: AttributeModel | EventModel;

  fetchLogs = task(async () => {
    return await this.store.query('log', {
      type: DATA_INDEX_TYPE_ACTIVITY_LOGS[this.model.type as keyof typeof DATA_INDEX_TYPE_ACTIVITY_LOGS],
      name: this.model.id,
      limit: 5,
    });
  });

  createSegment = task(async () => {
    let item = this.model;

    let segment = this.store.createRecord('segment', {
      name: `${item.id} ${item.type} segment`,
      description: 'Created using the Data Index',
      conditions: createConditionsJSON(item.type, item.id),
    });

    await segment.save();

    this.router.transitionTo('segments.segment.edit', segment.id);
  });

  createCampaign = task(async () => {
    let item = this.model;

    let campaign = this.store.createRecord('campaign', {
      name: `${item.id} event triggered campaign`,
      description: 'Created using the Data Index',
      event: item.id,
      type: 'transactional',
    });

    await campaign.save();

    this.router.transitionTo('campaigns.campaign.setup', campaign.id);
  });
}
